module.exports = __webpack_public_path__ + "static/media/luminatouch-1.1e98677d.jpg";